import { render, staticRenderFns } from "./InventoryFile.vue?vue&type=template&id=ab15e190"
import script from "./InventoryFile.vue?vue&type=script&lang=js"
export * from "./InventoryFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports